import {
  Users,
  Ruler,
  CalendarClock,
  Hammer,
} from "lucide-react";

const ProcessRoadmap = ({ title, subtitle, steps }) => {
  return (
    <section className="bg-background py-20 px-4 text-text">
      <div className="max-w-[1140px] mx-auto">
        {/* Heading */}
        <div className="text-left mb-12">
          <h2 className="text-4xl tracking-[6px] uppercase text-primary font-light mb-4">
            {title}
          </h2>
          <p className="text-xl font-light text-darkBackground font-gilda">{subtitle}</p>
        </div>

        {/* Roadmap Steps */}
        <div className="relative flex flex-col lg:flex-row items-center lg:items-start justify-between gap-y-12 lg:gap-x-6">
          {/* Dashed horizontal line */}
          <div className="hidden lg:block absolute top-[139px] left-0 right-0 border-t border-dashed border-primary z-0" />

          {steps.map((step, index) => (
            <div
              key={index}
              className="relative z-10 bg-white border border-[#f1eeeb] px-6 py-8 text-left w-full min-h-[320px] max-w-[300px] flex flex-col items-left"
            >
              {/* Step number */}
              <div className="absolute -top-6 w-10 h-10 rounded-full bg-primary text-white flex self-center items-center justify-center text-lg font-light shadow-md">
                {index + 1}
              </div>

              {/* Icon */}
              <div className="mb-4">{step.icon}</div>

              {/* Title */}
              <h3 className="text-xl font-gilda font-light text-black mb-2">{step.title}</h3>

              {/* Description */}
              <p className="text-md font-light text-gray leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessRoadmap;
